require("./app_ynet_audioArticlesRecommendationsComponenta.less")

import {
    ProcessedAudioArticlesRecommendationsItem,
    resolveImageSrc,
} from "../audioArticlesRecommendationsUtils";
import { AudioArticlesRecommendationsItemCard } from "./audioArticlesRecommendationsItemCard";

type AudioArticlesRecommendationsComponentaAppProps = {
    listData?: ProcessedAudioArticlesRecommendationsItem[];
    imagesDomain: string;
    domain: string;
};

interface AudioArticlesRecommendationsComponentaAppState {
    isClosed: boolean;
}

export class AudioArticlesRecommendationsComponentaApp extends React.Component<AudioArticlesRecommendationsComponentaAppProps, AudioArticlesRecommendationsComponentaAppState> {

    public static siteScriptName = "AudioArticlesRecommendationsComponentaApp";

    constructor(props: AudioArticlesRecommendationsComponentaAppProps) {
        super(props);
        this.state = {
            isClosed: false,
        };
    }

    private onClose = () => {
        this.setState({ isClosed: true });
    }

    render() {
        const { listData, imagesDomain, domain } = this.props;

        if (!listData || listData.length === 0) {
            return null;
        }

        if (this.state.isClosed) {
            return null;
        }

        return (
            <div className="AudioArticlesRecommendationsComponentaApp">
                <div className="recommendationsContainer">
                    <button className="closeButton" aria-label="close" onClick={this.onClose} />
                    <div className="recommendationsContent">
                        <div className="recommendationsHeader">
                            <div className="headerTitleRow">
                                <div className="headerLogoWrap">
                                    <span className="headerLogo" aria-hidden="true" />
                                </div>
                                <h3 className="headerTitle">אולי יעניין אתכם: חדש ב-</h3>
                            </div>
                        </div>

                        <div className="itemsContainer">
                            {_.map(listData, (item: ProcessedAudioArticlesRecommendationsItem) => {
                                const podcastId = item.id || item.articleId;
                                if (!podcastId) {
                                    return null;
                                }

                                const imageSrc = resolveImageSrc(item.imageUrl || "", imagesDomain || "");
                                const resolvedCategoryIconSrc = resolveImageSrc(
                                    item.categoryIcon || item.categoryIconSrc || "",
                                    imagesDomain || "",
                                );
                                const isVideoItem = item.hasVideo && item.videoData;
                                const video = item.videoData;
                                const mediaDuration = isVideoItem && item.videoData.duration
                                    ? item.videoData.duration
                                    : (item.duration || 0);
                                const scriptObj =
                                {
                                    id: podcastId,
                                    name: item.author || "",
                                    title: item.title,
                                    durationSeconds: mediaDuration,
                                    imageUrl: imageSrc || item.imageUrl || "",
                                    audioUrl: isVideoItem ? undefined : item.audioUrl || "",
                                    articleLink: item.link,
                                    podcastCategoryImage: resolvedCategoryIconSrc,
                                    podcastName: item.categoryName || "",
                                };
                                const scriptString = `window.podcastsData = window.podcastsData || {};
                                    window.podcastsData[${JSON.stringify(podcastId)}] = ${JSON.stringify(scriptObj)};`;
                                <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />

                                return (
                                    <AudioArticlesRecommendationsItemCard
                                        key={item.id}
                                        item={item}
                                        imagesDomain={imagesDomain}
                                        categoryIconFirst={true}
                                        href={isVideoItem ? `${domain}/video?path=${video.url}?videoId=${video.mediaId}&articleId=${podcastId}&advertisement=${item.hideVideoAds ? '0' : '1'}&blockAbroad=${video.blockAbroadViews ? `1` : `0`}${video.aspectRatio ? `&proportion=${video.aspectRatio}` : ""}${`&caption=${item.title}`}` : "//podcast/" + podcastId}
                                   >
                                    <script type="text/javascript" dangerouslySetInnerHTML={{ __html: scriptString }} />
                                   </AudioArticlesRecommendationsItemCard>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
